import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Product } from '../../../Model/Catalog/Product';
import { ValidationService } from '../../../Services/Validation/validation.service';
import { Shopware6ProductConfiguration } from '../../../Model/Catalog/shopware/Shopware6ProductConfigurations';
import { CatalogService } from '../../../Services/CatalogManagement/catalog.service';
import { UserManagementService } from '../../../Services/userManagment.service';
import { ShopwareSalesChannel } from '../../../Model/Dto/ShopwareSalesChannel';
import { lastValueFrom } from 'rxjs';

@Component({
  selector: 'np-product-shopware6',
  templateUrl: './product-shopware6.component.html'
})
export class ProductShopware6Component {
  @Input() model: Product = new Product();
  @Input() templateView: Boolean = false;
  @Input() selectedElements: string[] = [''];
  @Input() showDragHandle: boolean = false;
  @Input() dragFilter: string = 'noDrag';

  @Output() elementSelected = new EventEmitter<string>();
  @Output() excelElementDropped = new EventEmitter<any>();
  @Output() onValueChanged = new EventEmitter<any>();

  salesChannels: ShopwareSalesChannel[] = [];

  constructor(
    public translate: TranslateService,
    public validationService: ValidationService,
    public catalogService: CatalogService,
    public userManagementService: UserManagementService
  ) { }

  async ngOnInit(): Promise<void> {
    this.model.shopware6Configuration ??= new Shopware6ProductConfiguration();

    this.salesChannels = await lastValueFrom(this.catalogService.GetShopwareSalesChannel(
      this.catalogService.catalog.shopWareConnection.baseUri,
      this.catalogService.catalog.shopWareConnection.clientId,
      this.catalogService.catalog.shopWareConnection.clientSecret));
  }

  update(event = null, field?: string, system: string = '-1', element: string = '-1') {
    if (event) {
      event.dField = field;
      event.dSystem = system;
      event.dElement = element;
      event.createTemplateItem = true;
    }
    this.onValueChanged.emit(event);
  }

  showClearButton(): boolean {
    return !this.templateView;
  }

  public elementSelectFunction(event) {
    this.elementSelected.emit(event);
  }

  public excelElementDrop(e) {
    this.excelElementDropped.emit(e);
  }

  readOnly(name: string): boolean {
    return this.catalogService?.catalog?.isVirtual || !this.userManagementService.canEdit(name);
  }
}
